import { createUseStyles } from 'react-jss'

import { LightTheme } from '../../../theme'

import { CarouselDotStyle } from './carousel-dot.types'

export const useStyle = createUseStyles((theme: LightTheme) => ({
  dot: {
    borderRadius: 8,
    backgroundColor: ({ active }: CarouselDotStyle) =>
      active ? theme.colors.yellow : theme.colors.shadow,
    height: 8,
    width: 8
  }
}))
